import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "fd48b2cb-f370-437b-accb-32161a3929f4",
        authority: "https://login.microsoftonline.com/dec5601a-f249-415a-bb40-0ce75d0d96ff",
        // redirectUri: "https://proud-glacier-0ec0b710f.5.azurestaticapps.net/",
        // postLogoutRedirectUri: "https://proud-glacier-0ec0b710f.5.azurestaticapps.net/",

        // redirectUri: "http://localhost:3000",
        // postLogoutRedirectUri: "http://localhost:3000",
        redirectUri: "https://doassist.donyati.com/",
        postLogoutRedirectUri: "https://doassist.donyati.com/",
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                if (level === LogLevel.Error) {
                    console.error(message);
                }
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Error,
        },
    },
};

export const loginRequest = {
    scopes: ["user.read"],
};
